import React from 'react';
import ContentPage from './contentPage/contentPage';
import PageWrapper from 'src/containers/pageWrapper/pageWrapper';
import { Link } from 'react-router-dom';
import HalfImage from './halfImage/halfImage';

import styles from './offerPage.module.scss';
import { BtnLink } from '../forms/Forms';
import { routes } from 'src/routes';

const OfferPage = () => {
  return (
  <ContentPage>
    <PageWrapper className={styles.offer}>
      <HalfImage image="/images/offer/oferta-ogolne-pieczec.png">
        <h1 className="h1">Nasza oferta</h1>
        <p>Możesz się cieszyć Pobudką na trzy różne sposoby, ale zawsze z taką samą porcją
smaku, zapachu i koloru! Nasze pyszne propozycje zamówisz do domu, kupisz u
naszego przedstawiciela w swojej firmie lub w wybranych sklepach. W ofercie
Pobudki dostępne są: śniadania, kanapki, sałatki, zupy, obiady, desery, przekąski i
napoje. Wśród proponowanych dań znajdują się pozycje mięsne i wegetariańskie,
tradycyjna kuchnia polska i smaki świata. Każdy znajdzie coś dla siebie!</p>
      </HalfImage>
      <HalfImage image="/images/offer/sprzedaz-online-pieczec.png" invert>
        <h2>Sprzedaż on-line</h2>
        <p>Prowadzimy sprzedaż on-line, z dostawą do domu, na terenie niemal całej Polski.
Jeśli chcesz się upewnić, czy dojeżdżamy także do Ciebie wystarczy, że wpiszesz
swój kod pocztowy w zakładce <a href="https://www.pobudka.waw.pl/zasieg">zasięg</a>. W Pobudce sam decydujesz co i na ile dni
chcesz zamówić - możesz wybrać dowolną liczbę posiłków, na dowolną liczbę dni.
Wracasz do nas na własnych zasadach - kiedy tylko masz ochotę na pyszną
Pobudkę. Zamówienia online na następny dzień przyjmujemy do godziny 12:00.
Pozwala nam to na przygotowanie świeżych posiłków, które o poranku trafią pod
drzwi Twojego domu.</p>

      <BtnLink link={routes.menu()} className={styles.btn} type="orange">Złóż zamówienie</BtnLink>
      </HalfImage>
      <HalfImage image="/images/offer/oferta-sprzedaz-w-biurach-pieczec.png">
      <h2>Sprzedaż w biurach</h2>
      <p>Działamy w Warszawie, Katowicach, Krakowie, Wrocławiu, Łodzi i okolicach tych
miast.Każdego dnia odwiedzamy tysiące firm. Nasz przedstawiciel, Pan lub Pani
Pobudka, pojawią się o ustalonej porze z pysznymi, zapakowanymi daniami. To Ty i
Twoi współpracownicy każdego dnia decydujecie, czy i co chcecie od niego
kupić.Jeśli chcesz, żebyśmy zaczęli przyjeżdżać także to Twojej firmy, wystarczy, że
wypełnisz formularz kontaktowy. Skontaktujemy się z Tobą, omówimy wszystkie
szczegóły i umówimy się na dzień próbny. Sam przekonasz się, czy pyszna Pobudka
jest tym, czego potrzebujesz!</p>
        <BtnLink link={routes.deliveryToOffices()} className={styles.btn} type="orange">Dowiedz się więcej</BtnLink>
      </HalfImage>

      <HalfImage image="/images/offer/sprzedaz-w-sklepach-pieczec.png" invert>
      <h2>Sprzedaż w sklepach</h2>
      <p>Od zeszłego roku pyszne dania Pobudki wprowadziliśmy także do wybranych
sklepów.W Pobudce stawiamy na dobre jedzenie i dobre relacje, dlatego dla każdego
Partnera biznesowego przygotowujemy indywidualną, dostosowaną do jego potrzeb
ofertę. Jeśli chcesz poszerzyć asortyment w swoim sklepie o pyszne i zdrowe dania
Pobudki, skontaktuj się z nami, pisząc na adres: <a href="mailto:b2b@pobudka.pl">b2b@pobudka.pl</a></p>
      </HalfImage>

    </PageWrapper>
  </ContentPage>
  );
};
export default OfferPage;
